// import React from "react";
// import {
//   Box,
//   Button,
//   Typography,
//   Card,
//   CardContent,
//   Stack,
// } from "@mui/material";

// const MobileCustomCard = ({
//   card_id,
//   title,
//   description,
//   img,
//   onButtonClick,
// }) => {
//   return (
//     <Card
//       sx={{
//         width: { xs: "240px" },
//         height: { xs: "320px" },
//         display: "flex",
//         flexDirection: "column",
//         // alignItems: "center",
//         justifyContent: "space-between",
//         border: "1px solid #ddd",
//         borderRadius: "12px",
//         boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//         padding: "16px",
//         textAlign: "center",
//         transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition for animation
//         marginRight: "20px",
//         marginBottom: "20px",
//         marginTop: "20px",
//         marginLeft: "12px",
//       }}
//     >
//       {/* Image Section */}
//       <Stack
//         sx={{
//         //   border: "1px solid red",
//           display: "flex",
//           flexDirection: "row",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <Box
//           component="img"
//           src={img} // Dynamically load image
//           alt={title}
//           sx={{
//             // width: "100px",
//             // height: "100px",
//             width: { xl: "240px", xs: "100px" },
//             height: { xl: "240px", xs: "100px" },
//             borderRadius: "50%",
//             // marginTop: "16px",
//           }}
//         />
//       </Stack>

//       {/* Content Section */}
//       <CardContent sx={{ flexGrow: 1 }}>
//         <Typography
//           variant="h6"
//           sx={{ fontWeight: "bold", marginBottom: "8px" }}
//         >
//           {title}
//         </Typography>
//         {/* <Typography variant="body2" sx={{ color: "#555" }}>
//           {description}
//         </Typography> */}
//       </CardContent>

//       {/* Button Section */}
//       <Button
//         variant="outlined"
//         sx={{
//           marginBottom: "16px",
//           textTransform: "none",
//           backgroundColor: "white", // add this line
//           color: "#4c3bea",
//           borderColor: "#4c3bea",
//           "&:hover": {
//             backgroundColor: "#4c3bea",
//             color: "white",
//             borderColor: "#4c3bea",
//           },
//         }}
//         // onClick={() => onButtonClick()} // Call parent handler with card_id
//       >
//         Explore WhatsApp Use Cases
//       </Button>
//     </Card>
//   );
// };

// export default MobileCustomCard;

import React from "react";
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  Stack,
} from "@mui/material";
import { FaSearch } from "react-icons/fa";

const MobileCustomCard2 = ({
  card_id,
  title,
  description,
  img,
  onButtonClick,
}) => {
  return (
    <>

    
      <Box sx={{ width: 216, height: 356 }}>
        <Box
          sx={{
            width: 196,
            minHeight: 336,
            border: "1px solid #7A7A7A",
            borderRadius: "12px",
            backgroundColor: "#fff",
            position: "relative",
            marginLeft: "10px",
            zIndex: 10,
            overflow: "hidden",
          }}
        >
          {/* Top bar */}
          <Box
            sx={{
              height: "20px",
              backgroundColor: "#0a5193",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
            }}
          />

          {/* Top-left triangle ribbon */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: 0,
              height: 0,
              borderTop: "132px solid #1f86c0",
              borderRight: "132px solid transparent",
              borderTopLeftRadius: "12px",
              zIndex: 2,
            }}
          />

          {/* Ribbon Text */}
          <Typography
            sx={{
              position: "absolute",
              top: 20,
              left: 28,
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
              zIndex: 3,
            }}
          >
            {""}
          </Typography>

          {/* Center Icon */}
          <Box
            component="img"
            src={img} // Dynamically load image
            alt={title}
            sx={{
              position: "absolute",
              top: 36,
              right: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "64px",
              width: "64px",
              // border: "1px solid red",
            }}
          >
            {/* <FaSearch size={42} color="#333" /> */}
          </Box>

          {/* Title & Description */}
          <Box sx={{ mt: 14, px: 2, textAlign: "left" }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#054e92",
                fontWeight: "bold",
                mb: 1,
                fontSize: "15px",
              }}
            >
              {title}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontSize: "12.3px",
                color: "#555",
                textAlign: "left",
                lineHeight: 1.4,
              }}
            >
              {description}
            </Typography>

            <Button
              variant="outlined"
              size="medium"
              sx={{
                marginBottom: "16px",
                textTransform: "none",
                backgroundColor: "white", // add this line
                color: "#1976d2",
                borderColor: "#1976d2",
                "&:hover": {
                  backgroundColor: "#1976d2",
                  color: "white",
                  borderColor: "#1976d2",
                },
                marginTop: "16px",
              }}
              // onClick={() => onButtonClick()} // Call parent handler with card_id
            >
              Explore
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            border: "2px solid #0a5193",
            backgroundColor: "#0a5193",
            position: "relative",
            width: 216,
            minHeight: 100,
            bottom: 88,
            zIndex: 0,
            borderTopLeftRadius: "64px",
            borderTopRightRadius: "64px",
          }}
        >
          {""}
        </Box>
      </Box>
    </>
  );
};

export default MobileCustomCard2;


